import BCard from '../ui/generic/BCard';
import { IconCake, IconDeviceMobile, IconHelpCircle, IconMail, IconMapPin } from '@tabler/icons-react';
import useUser from '../../hooks/User';
import { formatDateFront } from '../../utils';
import { Tooltip } from 'react-tooltip';

const PersonalInfo = () => {
  const { data, isSuccess } = useUser();
  if (!isSuccess) {
    return;
  }
  return (
    <BCard>
      <BCard.Body>
        <div className={'flex flex-col gap-4'}>
          <div className={'w-full flex justify-center'}>
            <div
              id={'user'}
              className="relative inline-flex size-20 items-center justify-center overflow-visible rounded-full bg-gradient-to-b from-primary-500 via-primary-600 to-primary-700"
            >
              <span className="font-medium text-white">
                {data.surname.charAt(0)} {data.name.charAt(0)}
              </span>
            </div>
          </div>
          <p className={'text-center leading-none text-lg font-semibold text-slate-700'}>
            {data.surname} {data.name}
          </p>
          <Label icon={IconMail}>{data.email}</Label>
          <Label icon={IconDeviceMobile}>{data.phone}</Label>
          <Label icon={IconMapPin}>
            {data.address} {data.postal_code} {data.city}
          </Label>
          <Label icon={IconCake}>{formatDateFront(data.birth_day)}</Label>
          <p className={'flex items-center justify-center gap-1 text-xs font-normal text-slate-400 underline'}>
            Je souhaite modifier mes infos
            <IconHelpCircle data-tooltip-id="info-update" className={'size-4.5'} />
          </p>
          <Tooltip id="info-update">
            <div className={'flex flex-col max-w-40  w-full '}>
              <p>Pour mettre à jour vos informations personnelles, veuillez prendre contact avec votre coach au</p>
              <p>+33 1 71 18 23 97</p>
            </div>
          </Tooltip>
        </div>
      </BCard.Body>
    </BCard>
  );
};

const Label = ({ icon: Icon, children }) => {
  return (
    <div className={'justify-center items-center flex gap-1 '}>
      {Icon && <Icon className={'size-4.5'} />}
      <div className={'text-xs font-normal text-slate-500'}>{children}</div>
    </div>
  );
};
export default PersonalInfo;
